export default function PilotsSection() {
  const features = [
    { icon: 'ri-bar-chart-box-line', title: 'Objective flight scoring' },
    { icon: 'ri-radio-line', title: 'Radio call transcription' },
    { icon: 'ri-flight-takeoff-line', title: 'Pattern and landing analysis' },
    { icon: 'ri-lightbulb-line', title: 'Post-flight coaching insights' },
    { icon: 'ri-line-chart-line', title: 'Progress tracking across flights' }
  ];

  return (
    <section id="features" className="py-16 sm:py-20 lg:py-24 bg-gradient-to-b from-[#0A1628] to-[#0D1B2E]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6">Train smarter. Fly sharper.</h2>
          <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            WingmanFix helps instructors teach more effectively and helps pilots understand exactly how they fly. Every flight becomes a clear, reviewable lesson.
          </p>
        </div>

        {/* Split Visual */}
        <div className="grid md:grid-cols-2 gap-6 sm:gap-8 mb-12 sm:mb-16">
          <div className="relative rounded-2xl overflow-hidden border-2 border-[#00FFD1]/20 shadow-xl group hover:border-[#00FFD1]/40 transition-all">
            <img 
              src="https://public.readdy.ai/ai/img_res/3a9060cee381f5b8d109fdfa2402da4c.jpg"
              alt="CFI reviewing flight data"
              className="w-full h-56 sm:h-72 lg:h-80 object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/80 to-transparent"></div>
            <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6 right-4 sm:right-6">
              <p className="text-base sm:text-lg font-semibold text-white">CFI reviewing student performance</p>
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden border-2 border-[#00FFD1]/20 shadow-xl group hover:border-[#00FFD1]/40 transition-all">
            <img 
              src="https://readdy.ai/api/search-image?query=young%20student%20pilot%20looking%20at%20aviation%20training%20performance%20scores%20on%20tablet%20device%20inside%20small%20aircraft%20cockpit%20with%20modern%20avionics%20displays%20professional%20aviation%20photography&width=600&height=400&seq=student-tablet-001&orientation=landscape"
              alt="Student reviewing scores"
              className="w-full h-56 sm:h-72 lg:h-80 object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/80 to-transparent"></div>
            <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6 right-4 sm:right-6">
              <p className="text-base sm:text-lg font-semibold text-white">Student tracking progress</p>
            </div>
          </div>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4">
          {features.map((feature, idx) => (
            <div 
              key={idx}
              className="bg-[#0F1F35] rounded-xl p-4 sm:p-6 border border-gray-700 hover:border-[#00FFD1] transition-all hover:-translate-y-1 cursor-pointer group"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mb-3 sm:mb-4">
                <i className={`${feature.icon} text-2xl sm:text-3xl text-[#00FFD1] group-hover:scale-110 transition-transform`}></i>
              </div>
              <h3 className="text-sm sm:text-base font-medium text-white leading-snug">{feature.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}